export default __webpack_public_path__ + "1f984f71e171a7400d67648c49d78d14.svg";